<template>
    <div class="bill">
        <div class="bill-head">
            <!-- <div>结算周期</div> -->
            <div>快币类型</div>
            <div>数量(币)</div>
            <div>汇率</div>
            <div>金额</div>
            <!-- <div>详情</div> -->
        </div>
        <div class="bill-item" v-for="note in data.list" :key="note.id">
            <!-- <div>{{ "2017年#2" }}</div> -->
            <div>{{ note.currency_name }}</div>
            <div>{{ note.trans_amount+'币' }}</div>
            <div>{{ note.currency_rate }}</div>
            <div>{{ note | ticket_curr }}</div>
            <!-- <div>{{ note.remark }}</div> -->
        </div>
        <div class="bill-item bill-total" v-show="data.periodCurrPersonalSummary && data.periodCurrPersonalSummary.confirm_money < 0">
            <div>上期结余</div>
            <div>{{ data.periodCurrPersonalSummary | bonus }}</div>
        </div>
        <div class="bill-item bill-total">
            <div>合计</div>
            <div>{{ data.currPersonalSummary | bonus }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['data'],
        // filters:{
        //     bonus(obj){
        //         let val = obj ? obj.confirmMoney : 0;
        //         let num = parseFloat(val);
        //         return num>0?num+'元':'0元';
        //     },
        // },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";
    .bill{
        background:#fafbfd;
        // border-bottom: 1px solid #d9dfe7;
        .bill-head,.bill-item{
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #d9dfe7;
            color:@font_list;
            font-size:12px;
            padding-left:50px;
            box-sizing: border-box;
            >div{
                float:left;
            }
            >div:nth-of-type(1){
                width:15%;
            }
            >div:nth-of-type(2){
                width:15%;
            }
            >div:nth-of-type(3){
                width:15%;
            }
            >div:nth-of-type(4){
                width:15%;
            }
            >div:nth-of-type(5){
                width:15%;
            }
            >div:nth-of-type(6){
                width:25%;
            }

            &.bill-total{
                color:#333;
                >div:nth-of-type(1){
                    padding-left: 30%;
                    width:15%;
                    font-weight: 600;
                }
                >div:nth-of-type(2){
                    width:15%;
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// bill.vue?de96507e